@if(entity)
{
<h2> Bench Template ({{entity.benchTemplateStatus}})</h2>
}

<div class="stepChart">
  <kendo-stepper [steps]="steps"
                 stepType="full"
                 [(currentStep)]="current"
                 [linear]="true"
                 [style.width.px]="570">
  </kendo-stepper>
</div>

<app-detail [name]="name"
            [id]="id"
            [apiController]="apiController"
            [views]="views"
            viewType="compressed"
            [toolbarItems]="toolbarItems"
            [keyFieldName]="keyFieldName"
            (entityLoaded)="entityLoaded()"
            [(entity)]="entity"
            [removeDefaultToolbarItems]=removeDefaultToolbarItems
            [showSaveButton]="showSaveButton"
            [showRemoveButton]="false"
            [breadCrumbPropertyNames]="breadCrumbPropertyNames">

</app-detail>

<kendo-stacklayout orientation="vertical" style="width:100%">
  <div class="gridsContainer">

    <div #orderSection>
      <form novalidate #orderForm="ngForm">
        <!--@if(entity) {-->
        <kendo-grid #grid
                    id="benchTemplateInstructionsGrid"
                    [data]="entity.benchTemplateItems"
                    [pageable]="pagerSettings"
                    [pageSize]="pageSize"
                    [sortable]="true"
                    [reorderable]="true"
                    (columnReorder)="onColumnReorder($event)"
                    filterable="menu, row"
                    [resizable]="true"
                    [groupable]="false"
                    [navigable]="true"
                    (dblclick)="onGridDoubleClicked($event)"
                    [selectable]="selectableSettings"
                    (cellClick)="onCellClicked($event)"
                    [skip]="state.skip || 0"
                    [sort]="state.sort || []"
                    style="height:100%; width: 100%">

          <ng-template kendoGridToolbarTemplate let-data>
            @if(showInlineAction){
            <div>
              <button kendoButton
                      (click)="editHandler(grid)"
                      [disabled]="isEdited"
                      [svgIcon]="editIcon"
                      class="warning"
                      style="margin: 5px 5px">
                Edit Bench Instructions
              </button>
              <button kendoButton
                      class="primary"
                      (click)="saveHandler(grid)"
                      [disabled]="!isEdited"
                      [svgIcon]="saveIcon"
                      style="margin: 5px 5px;">
                Save Bench Instructions
              </button>
              <button kendoButton
                      (click)="cancelHandler(grid)"
                      class="danger"
                      [disabled]="!isEdited"
                      [svgIcon]="cancelIcon"
                      style="margin: 5px 5px">
                Cancel
              </button>
            </div>
            }
            <button kendoButton
                    (click)="saveColumnReorder(grid)"
                    class="purpleBg"
                    [disabled]="false"
                    [svgIcon]="saveIcon"
                    style="margin: 5px 5px">
              Save Column Order
            </button>
          </ng-template>

          <kendo-grid-column field="line" title="Line Number" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="sku" title="EPC SKU" filter="text" [width]="120" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="description" title="Description" filter="text" [width]="120" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="serialNumber" title="Serial Number" filter="text" [width]="120" [editable]="false"></kendo-grid-column>

          <!--Editable columns for the Engineer to complete-->
          <kendo-grid-column field="hostName" title="Hostname" filter="text" [width]="300" [editable]="showHostnameSoftwareInstructions" [style]="{ 'background-color': 'rgb(192 254 164)' }">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <kendo-textbox [(ngModel)]="dataItem.hostName"
                             name="hostName{{rowIndex}}">
              </kendo-textbox>
            </ng-template>
          </kendo-grid-column>


          <kendo-grid-column field="softwareVersions" title="Software/Firmware Versions" filter="text" [width]="300" [editable]="showHostnameSoftwareInstructions" [style]="{ 'background-color': 'rgb(192 254 164)' }">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <kendo-textbox [(ngModel)]="dataItem.softwareVersions"
                             name="softwareVersions{{rowIndex}}">
              </kendo-textbox>
            </ng-template>
          </kendo-grid-column>



          <kendo-grid-column field="instructions" title="Staging and Integration Instructions" filter="text" [width]="300" [editable]="showHostnameSoftwareInstructions" [style]="{ 'background-color': 'rgb(192 254 164)' }">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <textarea (keydown.enter)="$event.stopImmediatePropagation()"
                        [(ngModel)]="dataItem.instructions"
                        kendoGridFocusable
                        name="instructions{{rowIndex}}"
                        rows="5"
                        cols="35">
              </textarea>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="connectionInformation" title="Connection Information" filter="text" [width]="300" [editable]="showConnectionInfo" [style]="{ 'background-color': 'rgb(164 233 254)' }">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <textarea (keydown.enter)="$event.stopImmediatePropagation()"
                        [(ngModel)]="dataItem.connectionInformation"
                        kendoGridFocusable
                        name="connectionInformation{{rowIndex}}"
                        rows="5"
                        cols="35">
              </textarea>
            </ng-template>
          </kendo-grid-column>

          <!--End editable columns-->

          <kendo-grid-column field="epcUniqueIdentifier" title="EPC Unique Identifier" filter="text" [width]="120" [editable]="false"></kendo-grid-column>
          @if(showCustomField1){
          <kendo-grid-column field="customField1" title="{{entity.customField1Title}}" filter="text" [width]="120" [editable]="false"></kendo-grid-column>
          }

          <ng-template kendoGridDetailTemplate let-dataItem="dataItem">
            <div>
              <app-grid-detail [columns]="subGridSettings.columns" [dataItem]="dataItem" [dataProperty]="subGridSettings.subGridDataProperty"></app-grid-detail>
            </div>
          </ng-template>

          <div>
          </div>
        </kendo-grid>
        <kendo-contextmenu #gridMenu
                           [kendoMenuHierarchyBinding]="contextMenuItems"
                           [textField]="'title'"
                           childrenField="items"
                           svgIconField="iconClass"
                           separatorField="separator"
                           (select)="onContextMenuSelect($event)">
        </kendo-contextmenu>
        <!--}-->
      </form>
    </div>
  </div>
  <br />
  @if(showBenchTemplateWarning){
  <div #feedback id="feedback-section" role="alert" class="alert alert-error" style="text-align:left;">
    If you need to change the Hostname, Software/Firmware, Instructions, etc, please contact wfredeploy&#64;epcusa.com.
  </div>

  <div #feedback id="feedback-section" role="alert" class="alert alert-error" style="text-align:left;">
    If everything is finished, please proceed to press the Finalize button to finish.
  </div>
  }

  @if (openDialog) {
  <kendo-dialog title="Set Status" [animation]="true" (close)="closeConfirmDialog()">
    @if(showExtraInfo){
    <p>
      {{finalizeWarningDescription}}
    </p>
    }
    <p>Are you sure you want to set the status to {{dialogStatus}}?</p>

    <kendo-dialog-actions>
      <button kendoButton (click)="closeConfirmDialog()" [svgIcon]="dialogNo">
        No
      </button>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="setBenchTemplateStatus()" [svgIcon]="dialogYes">
        Yes
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="setBenchTemplateStatus()">
        Yes
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>



